import useSWR from "swr";
import { mapRawToMeasurement } from "@/mappers/measurement";
import { Measurement, RawMeasurement } from "@/types/measurement";
import { SWRApiError, swrConfigOptions, useFetcher } from "./swr";

export const useMeasurementsByMeasurementRequest = (measurementRequestId?: number) => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawMeasurement[], SWRApiError>(
    measurementRequestId
      ? { url: `/measurements/measurement_request/${measurementRequestId}` }
      : null,
    fetcher,
    swrConfigOptions,
  );

  return { data: data.map(mapRawToMeasurement), ...rest } as {
    data: Measurement[];
  } & typeof rest;
};
